import * as angular from "angular";
import {IController} from 'angular';

export class bringozSelectItemCtrl implements IController {

  id: any;
  name: any;
  subtitle: any;
  doTranslate: boolean;
  isSelected: boolean;
  onSelect: Function;

  constructor() {}

}

angular
  .module('bringoz.admin.commons')
  .component('bringozSelectItem', {
    bindings: {
      id: '<',
      name: '<',
      subtitle: '<?',
      doTranslate: '<?',
      isExcluded: '<?',
      isSelected:'<?'
    },
    template: require('./bringoz-select-item.html').default,
    controller: bringozSelectItemCtrl
  });
